import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

/* ═══════════════════════════════════════════════════════════════
   SalesNav — Nav marketing DIKONGSI (satu sumber, auto-sync).
   Dipakai oleh SalesPageView (/sesaat-1) + PricingBaruView (/pricing-baru).
   Edit sini SEKALI → kedua-dua page ikut.
   Self-contained (tiada pergantungan pada .ugc-page CSS vars) supaya
   boleh guna di mana-mana. Tokens ikut salespage: cream #f4f3ef,
   border #e6e3db, lime #bef264.

   Props:
     onLogin   — dipanggil bila klik "Log In" / "Sign Up" (belum login)
     onPricing — dipanggil bila klik pautan "Pricing"
     onLogout  — kalau diberi & user login: papar "Log Keluar" ganti "Dashboard"
                 (dipakai StartGate — gate tiada guna butang Dashboard)
   ═══════════════════════════════════════════════════════════════ */
export default function SalesNav({ onLogin, onPricing, onLogout }) {
    const navigate = useNavigate();
    const [user, setUser] = useState(() => auth.currentUser);
    useEffect(() => onAuthStateChanged(auth, setUser), []);
    // Logo → home salespage. Pricing/Products/Guides/Docs → page harga buat masa ni.
    const goHome = () => navigate('/');
    const goPricing = () => (onPricing ? onPricing() : navigate('/pricing'));
    // Dashboard → app SENTIASA di app.sesaat.ai; kalau nav ni render di sesaat.ai (domain marketing),
    // kena full redirect ke domain app — navigate() dalaman akan buka app atas domain salah.
    const goDashboard = () => {
        const isMainDomain = window.location.hostname === 'sesaat.ai' || window.location.hostname === 'www.sesaat.ai';
        if (isMainDomain) { window.location.href = 'https://app.sesaat.ai/dashboard'; return; }
        navigate('/dashboard');
    };
    // Features → scroll ke section #features di salespage. Kalau tak wujud (page lain),
    // navigate ke home dulu, poll sampai section render, baru scroll.
    const goFeatures = () => {
        const here = document.getElementById('features');
        if (here) { here.scrollIntoView({ behavior: 'smooth' }); return; }
        navigate('/');
        let tries = 0;
        const tick = () => {
            const el = document.getElementById('features');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
            else if (tries++ < 20) setTimeout(tick, 100);
        };
        setTimeout(tick, 100);
    };
    return (
        <nav
            className="sticky top-0 z-50"
            style={{
                background: 'rgba(244,243,239,0.75)',
                backdropFilter: 'blur(14px) saturate(1.4)',
                WebkitBackdropFilter: 'blur(14px) saturate(1.4)',
                borderBottom: '1px solid #e6e3db',
            }}
        >
            <div className="w-full px-6 lg:px-12 h-16 flex items-center justify-between gap-4">
                {/* Kiri: logo + pautan */}
                <div className="flex items-center gap-8 min-w-0">
                    <div onClick={goHome} className="flex items-center gap-2 shrink-0 cursor-pointer">
                        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center shrink-0">
                            <span className="material-symbols-outlined text-white text-[16px]" style={{ fontVariationSettings: "'FILL' 1" }}>bolt</span>
                        </div>
                        <span className="text-base font-extrabold tracking-tight text-slate-900">SESAAT</span>
                    </div>
                    <div className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-600">
                        <span onClick={goFeatures} className="cursor-pointer hover:text-slate-900 transition-colors">Features</span>
                        <span onClick={goHome} className="cursor-pointer hover:text-slate-900 transition-colors inline-flex items-center gap-0.5">Products <span className="material-symbols-outlined text-[18px]">expand_more</span></span>
                        <span onClick={goPricing} className="cursor-pointer hover:text-slate-900 transition-colors">Pricing</span>
                        <span onClick={goHome} className="cursor-pointer hover:text-slate-900 transition-colors inline-flex items-center gap-0.5">Guides <span className="material-symbols-outlined text-[18px]">expand_more</span></span>
                        <span onClick={goHome} className="cursor-pointer hover:text-slate-900 transition-colors">Docs</span>
                    </div>
                </div>
                {/* Kanan: log masuk + daftar */}
                <div className="flex items-center gap-3 shrink-0">
                    {user && onLogout ? (
                        <button onClick={onLogout} className="h-9 px-4 inline-flex items-center gap-1.5 rounded-xl text-sm font-bold text-slate-700 border border-slate-200 bg-white hover:bg-slate-50 transition-colors">
                            <span className="material-symbols-outlined text-[18px]">logout</span> Log Keluar
                        </button>
                    ) : user ? (
                        <button onClick={goDashboard} className="h-9 px-4 inline-flex items-center gap-1.5 rounded-xl text-sm font-bold text-slate-900 bg-lime-300 hover:bg-lime-200 transition-colors">
                            <span className="material-symbols-outlined text-[18px]">dashboard</span> Dashboard
                        </button>
                    ) : (
                        <>
                            <button onClick={onLogin} className="hidden sm:inline-flex h-9 px-4 items-center rounded-xl text-sm font-bold text-slate-700 border border-slate-200 bg-white hover:bg-slate-50 transition-colors">Log In</button>
                            <button onClick={onLogin} className="h-9 px-4 inline-flex items-center rounded-xl text-sm font-bold text-slate-900 bg-lime-300 hover:bg-lime-200 transition-colors">Sign Up</button>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
}
